import { Tabs } from '@mantine/core';
import { ProfileUser } from '../ProfileUser';
import { BiggestGames } from './BiggestGames';
import { FavoriteGames } from './FavoriteGames';
import { RecentlyPlayedGames } from './RecentlyPlayedGames';
import { StatsCategory } from './StatsCategory';
export const Stats: React.FC = () => {
  return <Tabs.Panel value="stats">
      <ProfileUser />
      <StatsCategory />
      <BiggestGames />
      <FavoriteGames />
      <RecentlyPlayedGames />
    </Tabs.Panel>;
};